<ng-scrollbar>
  <app-spinner-overlay></app-spinner-overlay>
  <div style="padding-right: 20px" *ngIf="datiSurvey">
    <div class="contenuto">
      <app-anteprima-doppia-materialita-suvey
        [idSurveyCompilato]="data.idSurveyCompilato"
        #surveyDoppiaMat
        *ngIf="struttraSurvey"
        [datiSurvey]="struttraSurvey"
        [landingPage]="landingPage"
      ></app-anteprima-doppia-materialita-suvey>
    </div>

    <!----------------------------- F O O T E R ------------------------>
    <div mat-dialog-actions class="dialog-footer-cont">
      <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>

      <div *ngIf="!data.idSurveyCompilato">
        <button mat-flat-button color="primary" (click)="salva()" class="primary-button">
          Salva
        </button>
      </div>
    </div>
  </div>

  <div class="no-dati" *ngIf="!datiSurvey">
    <div class="no-dati">
      {{ erroreDatiSurvey }}
    </div>
  </div>
</ng-scrollbar>
